export default __webpack_public_path__ + "static/media/STBAPLockup_V2.00511a12.jpg";